import { readJson, writeJson } from '../api/storage';
import type { Id } from '../api/types';
import { keepRecentRow, migrateRecentRows, type RecentFilter } from './recentRows';

const RECENT_KEY = 'izqlt.recent';
const RECENT_VERSION_KEY = 'izqlt.recent.version';
const RECENT_LIMIT = 20;

export interface RecentLecture {
  unitId: string;
  unitName?: string;
  courseId?: string;
  classId: string;
  classTitle?: string;
  subjectTitle?: string;
  /** Reopening needs these to revive the Quản lý lớp rail. Rows written before they existed lack them. */
  subjectId?: Id;
  gradeId?: Id;
  /** The note for THIS row's `date` only - reused on another day it files the period under the wrong note. */
  classNoteId?: Id;
  index: number;
  date: string;
  openedAt: string;
  /** Who closed the period, so a shared panel never lists another teacher's lectures. */
  teacherId?: string;
}

/** Stored rows, cleaned once per schema version; the key survives upgrades and can hold any old shape. */
function storedRecentLectures(): RecentLecture[] {
  const migrated = migrateRecentRows<RecentLecture>(readJson<unknown>(RECENT_KEY), readJson<number>(RECENT_VERSION_KEY));
  if (migrated.changed) {
    writeJson(RECENT_KEY, migrated.rows);
    writeJson(RECENT_VERSION_KEY, migrated.version);
  }
  return migrated.rows;
}

/** Rows worth showing: real ids, this teacher's, and one of their current classes when those are known. */
export function readRecentLectures(filter: RecentFilter = {}): RecentLecture[] {
  return storedRecentLectures().filter((row) => keepRecentRow(row, filter));
}

export function saveRecentLecture(entry: RecentLecture): void {
  const deduped = storedRecentLectures().filter((item) => !(item.unitId === entry.unitId && item.classId === entry.classId));
  writeJson(RECENT_KEY, [entry].concat(deduped).slice(0, RECENT_LIMIT));
}

export function relativeLectureTime(value: string, now = Date.now()): string {
  const elapsedMinutes = Math.max(0, Math.floor((now - new Date(value).getTime()) / 60000));
  if (elapsedMinutes < 1) return 'Vừa xong';
  if (elapsedMinutes < 60) return `${elapsedMinutes} phút trước`;
  const hours = Math.floor(elapsedMinutes / 60);
  if (hours < 24) return `${hours} giờ trước`;
  return `${Math.floor(hours / 24)} ngày trước`;
}
